import { dateDifference } from "@/constants/date";
import { ToDateOptionsWithTZ, toZonedTime } from "date-fns-tz";

const resolveZonedTime = (
  date: Date | string | number,
  options?: ToDateOptionsWithTZ & {
    timezone?: string;
    withoutDateDifference?: boolean;
  },
) => {
  const { timezone, withoutDateDifference, ...rest } = options ?? {};
  const zonedDate = new Date(
    toZonedTime(
      date,
      timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
      rest,
    ).getTime() - (withoutDateDifference ? 0 : dateDifference.valueOf()),
  );
  return zonedDate;
};

export default resolveZonedTime;
